const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://revival-pharmacy.onrender.com/api';

export function getApiBaseUrl() {
  return API_BASE_URL;
}

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = sessionStorage.getItem('revival_admin_token');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!(options.body instanceof FormData)) headers.set('Content-Type', 'application/json');

  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  const contentType = response.headers.get('content-type') || '';
  const body = contentType.includes('application/json') ? await response.json() : null;
  if (!response.ok) {
    throw new Error(body?.error || `Request failed with status ${response.status}.`);
  }
  return body;
}

export const api = {
  login: (credentials) => request('/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),
  me: () => request('/auth/me'),
  gallery: () => request('/gallery'),
  publicSettings: () => request('/settings'),
  uploadGallery: (file) => {
    const form = new FormData();
    form.append('image', file);
    return request('/gallery', { method: 'POST', body: form });
  },
  deleteGallery: (id) => request(`/gallery/${id}`, { method: 'DELETE' }),
  messages: () => request('/admin/messages'),
  updateMessage: (id, status) => request(`/admin/messages/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  }),
  deleteMessage: (id) => request(`/admin/messages/${id}`, { method: 'DELETE' }),
  services: () => request('/admin/services'),
  updateService: (id, status) => request(`/admin/services/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  }),
  settings: () => request('/admin/settings'),
  updateSettings: (settings) => request('/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  }),
};
